import { API_URL } from '../../../app-config/constants';
import type { AnytimeFeedbackStats } from '../../react/features/YourFeedback/types';
import { get } from '../request';

getAnytimeFeedbackStats.operation = 'READ';
getAnytimeFeedbackStats.idFrom = 'ARGS';
export function getAnytimeFeedbackStats(from: string, to: string): Promise<AnytimeFeedbackStats> {
    return get(`${API_URL}/anytime-feedback-stats`, {
        getData: {
            from,
            to,
        },
    });
}
